"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multicallTransformed = exports.multicallv2 = void 0;
var abi_1 = require("@ethersproject/abi");
var web3_utils_1 = require("web3-utils");
var Multicall_json_1 = __importDefault(require("../../abi/Multicall.json"));
var profile_1 = require("../../shared/utils/profile");
function getMulticallContract(_a) {
    var web3 = _a.web3, chainId = _a.chainId;
    var address = {
        // ETH
        '0x1': '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        1: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        // ropsten
        '0x11': '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        3: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        // local ETH
        1337: '0x9561C133DD8580860B6b7E504bC5Aa500f0f06a7',
        // BSC
        '0x38': '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
        56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
        // testnet BSC
        '0x61': '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
        97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
        //Polygon
        137: '0xed386fe855c1eff2f843b910923dd8846e45c5a4',
        // Avax
        43114: '0x2260d9472D18A50BC671369FB942452dD192C4Dc',
        // Arbitrum
        42161: '0xfAfd3E2f3DEb190C0b34fd10297095F4a0a2ad9F',
        8453: '0xca11bde05977b3631167028862be2a173976ca11',
        // Zksync
        324: '0x47898B2C52C957663aE9AB46922dCec150a2272c',
    }[chainId];
    if (!address) {
        throw new Error("Invalid chain ".concat(chainId));
    }
    return new web3.eth.Contract(Multicall_json_1.default, address);
}
var MulticallError = /** @class */ (function (_super) {
    __extends(MulticallError, _super);
    function MulticallError(prevError, chainId) {
        var _this = _super.call(this, prevError === null || prevError === void 0 ? void 0 : prevError.message) || this;
        _this.prevError = prevError;
        _this.chainId = chainId;
        return _this;
    }
    return MulticallError;
}(Error));
/**
 * Multicall V2 uses the new "tryAggregate" function. It is different in 2 ways
 *
 * 1. If "requireSuccess" is false multicall will not bail out if one of the calls fails
 * 2. The return inclues a boolean whether the call was successful e.g. [wasSuccessfull, callResult]
 */
var multicallv2 = function (_a) {
    var web3 = _a.web3, abi = _a.abi, calls = _a.calls, _b = _a.options, options = _b === void 0 ? {} : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var chainId, _c, interfaces, getInterface, instance, calldata, returnData, transformed, e_1;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _c = ((_d = web3.currentProvider) === null || _d === void 0 ? void 0 : _d.chainId);
                    if (_c) return [3 /*break*/, 2];
                    return [4 /*yield*/, web3.eth.getChainId()];
                case 1:
                    _c = (_e.sent());
                    _e.label = 2;
                case 2:
                    chainId = _c;
                    if (typeof chainId === 'string' && chainId.indexOf('0x') > -1) {
                        chainId = parseInt(chainId, 16);
                    }
                    interfaces = {};
                    getInterface = function (contractName) {
                        return interfaces[contractName] ||
                            new abi_1.Interface(contractName ? abi[contractName] : abi);
                    };
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    instance = getMulticallContract({ web3: web3, chainId: chainId });
                    calldata = calls.map(function (call) { return [
                        call.address.toLowerCase(),
                        getInterface(call.contractName).encodeFunctionData(call.name, call.params),
                    ]; });
                    return [4 /*yield*/, instance.methods
                            .tryAggregate(options.requireSuccess === undefined ? false : options.requireSuccess, calldata)
                            .call(undefined, options.blockNumber)];
                case 4:
                    returnData = _e.sent();
                    transformed = returnData.map(function (call, i) {
                        var _a;
                        var encodedResult = call[0], data = call[1];
                        var decoded = encodedResult
                            ? getInterface(calls[i].contractName).decodeFunctionResult(calls[i].name, data)
                            : null;
                        return ((_a = options.transformBN) !== null && _a !== void 0 ? _a : true)
                            ? transformBigNumberToString(decoded)
                            : transformBigNumberToBN(decoded);
                    });
                    return [2 /*return*/, (options.unwrapValues ? transformed.flat() : transformed)];
                case 5:
                    e_1 = _e.sent();
                    throw new MulticallError(e_1, chainId);
                case 6: return [2 /*return*/];
            }
        });
    });
};
exports.multicallv2 = multicallv2;
var promises = {};
var EXPIRES_IN = 10 * 1000;
function multicallTransformed(_a) {
    var web3 = _a.web3, abi = _a.abi, address = _a.address, methods = _a.methods, args = _a.args, returnCachedOnError = _a.returnCachedOnError, transformBN = _a.transformBN;
    return __awaiter(this, void 0, void 0, function () {
        var calls, key, data_1, e_2, cached_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    calls = Object.keys(methods).map(function (method) { return ({
                        address: address,
                        name: method,
                        params: args === null || args === void 0 ? void 0 : args[method],
                    }); });
                    key = __spreadArray(__spreadArray([
                        address
                    ], Object.keys(methods).map(function (v) { return v.substr(0, 5); }), true), [
                        args
                            ? Object.values(args)
                                .map(function (v) { return v; })
                                .join()
                            : '',
                    ], false).join(':');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (!promises[key]) {
                        (0, profile_1.profileInc)('multicall', address);
                        promises[key] = (0, exports.multicallv2)({
                            web3: web3,
                            abi: abi,
                            calls: calls,
                            options: { transformBN: transformBN },
                        });
                        setTimeout(function () {
                            promises[key] = null;
                        }, EXPIRES_IN);
                    }
                    return [4 /*yield*/, promises[key]];
                case 2:
                    data_1 = _b.sent();
                    if (returnCachedOnError) {
                        cache(key, data_1);
                    }
                    // TODO: convert to object
                    // return Object.keys(methods).reduce((acc, k) => {
                    //   const args =
                    //     Array.isArray(data[k]) && data[k].length > 1 ? [data[k]] : data[k];
                    //   acc[k] = methods[k](...(args || []));
                    //   return acc;
                    // });
                    return [2 /*return*/, Object.values(methods).map(function (fn, k) {
                            var args = Array.isArray(data_1[k]) && data_1[k].length > 1 ? [data_1[k]] : data_1[k];
                            // @ts-ignore
                            return fn.apply(void 0, (args || []));
                        })];
                case 3:
                    e_2 = _b.sent();
                    if (returnCachedOnError) {
                        cached_1 = getCached(key);
                        if (cached_1) {
                            console.warn('Multicall: return cached on error', e_2);
                            return [2 /*return*/, Object.values(methods).map(function (fn, k) {
                                    var args = Array.isArray(cached_1[k]) && cached_1[k].length > 1
                                        ? [cached_1[k]]
                                        : cached_1[k];
                                    // @ts-ignore
                                    return fn.apply(void 0, (args || []));
                                })];
                        }
                    }
                    delete promises[key];
                    console.warn("Multicall failed", {
                        address: address,
                        calls: JSON.stringify(calls),
                        chainId: e_2 === null || e_2 === void 0 ? void 0 : e_2.chainId,
                    });
                    throw e_2;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.multicallTransformed = multicallTransformed;
function cache(k, v) {
    if (typeof window !== 'undefined' &&
        typeof window.localStorage !== 'undefined') {
        window.localStorage.setItem(k, JSON.stringify(v));
    }
}
function getCached(k) {
    if (typeof window !== 'undefined' &&
        typeof window.localStorage !== 'undefined') {
        try {
            return JSON.parse(window.localStorage.getItem(k));
        }
        catch (e) {
            return undefined;
        }
    }
}
function transformBigNumberToString(result) {
    if (!result) {
        return result;
    }
    if (result === null || result === void 0 ? void 0 : result._isBigNumber) {
        return result.toString();
    }
    if (typeof result === 'object') {
        var transformed = Object.keys(result).reduce(function (acc, k) {
            acc[k] = transformBigNumberToString(result[k]);
            return acc;
        }, []);
        return transformed;
    }
    return result;
}
function transformBigNumberToBN(result) {
    if (!result) {
        return result;
    }
    if (result === null || result === void 0 ? void 0 : result._isBigNumber) {
        return (0, web3_utils_1.toBN)(result.toString());
    }
    if (typeof result === 'object') {
        var transformed = Object.keys(result).reduce(function (acc, k) {
            acc[k] = transformBigNumberToBN(result[k]);
            return acc;
        }, []);
        return transformed;
    }
    return result;
}
